module.exports = __webpack_public_path__ + "static/img/report_img_bjstggaqzb.2c4a7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_bjstggaqzb.png
// module id = ThoA
// module chunks = 21